import {AppController} from "@ok/web/modules/block/AppController";
import {ClipsFullscreenStore} from "./ClipsFullscreenStore";
import {Navigation} from "@ok/web/modules/navigation/Navigation";
import {UpdateType} from "./helpers/LinkHelper";
import {AnimationType} from "./types";
import {CLIPSFULLSCREEN_STATE, FADE_OUT_TIMING} from "../config";
import type {OneVideoPlayerElement} from "@ok/video-player";

export class ClipsFullscreenController extends AppController<ClipsFullscreenStore> {
    handleClose = () => {
        this.store.setIsStopCurrentClip(true);

        if (this.store.returnUrl && window.pageCtx.stateId === CLIPSFULLSCREEN_STATE) {
            Navigation.pushState(this.store.returnUrl);
            this.store.setNavigationRunningState(true);
            window.OK.navigationInterop.navigated.attachOnce(() => {
                this._handleClose();
                this.store.setNavigationRunningState(false);
            });
        } else {
            const initTarget = this.store.initTarget as unknown as OneVideoPlayerElement;
            if (initTarget) {
                initTarget.removeAttribute("style");
                const parent = initTarget.closest(".one-video-player-wrapper");
                if (parent) {
                    parent.removeAttribute("style");
                    parent.scrollIntoView({block: "center"});
                }
                if (initTarget.call) {
                    const initialClipMovieId = this.store.initialClipMovieId;
                    if (!initialClipMovieId) {
                        return;
                    }
                    const initialClipSavedPosition = this.store.getClipPosition(initialClipMovieId);

                    if (initialClipSavedPosition) {
                        initTarget.call("seek", initialClipSavedPosition.currentTime);
                    }
                }
            }

            this._handleClose();
        }
    };

    handleRetry = () => {
        this.store.setIsLoadError(false);
        this.store.hideToast();
    };

    private _handleClose = () => {

        this.store.setIsVisible(false);
        this.store.setAnimationType(AnimationType.FADE_OUT);
        this.store.setIsStopCurrentClip(false);
        this.store.clearItemsListBouncingAnimation();

        if (!this.store.isInitialThemeDark && document.documentElement.classList.contains("dark-theme")) {
            document.documentElement.classList.remove("dark-theme");
        }

        if (!this.store.isFullscreenClosedViaSystemBack && this.store.isHandleSystemBackFeatureEnabled && !this.store.isDisableSystemBackHandling) {
            this.store.setNeedToHandleSystemBack(false);
            if (!this.store.isNavigationRunning && window.pageCtx && window.pageCtx.stateId !== CLIPSFULLSCREEN_STATE) {
                Navigation.back();
            }
        }

        setTimeout(() => {
            this.store.setOpenState(false);
            this.store.linkHelper.updateHref(UpdateType.CLEAR);
            this.store.clearClips();
            this.store.clearClipsProgressPositions();
            this.store.setOffsetTo(0);
            this.store.setIsLoadError(false);
            this.store.setIsFullscreenClosedViaSystemBack(false);
            this.store.setNeedToHandleSystemBack(true);
            this.store.unionObserver = null;
        }, FADE_OUT_TIMING);
    };
}
